import {skipToken} from '@reduxjs/toolkit/query';

import {isNil} from 'ramda';

import {useGetTenantIntegrationsAdvancedSearchQuery} from '@dms/api/core';

import {useTenant} from './useTenant';

const HYUNDAI_MOBIS_IRIS_INTEGRATION_CODE = 'HYUNDAI_MOBIS_IRIS';
const MERCEDES_MRA_INTEGRATION_CODE = 'MRA_REPORTING';
const DAIMLER_MRA_INTEGRATION_CODE = 'DAIMLER_MRA_REPORTING';
const MERCEDES_5STAR_INTEGRATION_CODE = 'MERC_5STAR';
const MERCEDES_CSTAR_INTEGRATION_CODE = 'MERC_CSTAR';

export function useImporterReportingIntegrations() {
  const tenantData = useTenant();
  const tenantId = tenantData.tenant?.id;

  const tenantIntegrationsQuery = useGetTenantIntegrationsAdvancedSearchQuery(
    isNil(tenantId)
      ? skipToken
      : {
          tenantId,
        }
  );

  const integrations = tenantIntegrationsQuery.data;
  const isTenantIntegrationsSearchSuccess = tenantIntegrationsQuery.isSuccess;

  const codes = new Set(integrations?.map((integration) => integration.code) ?? []);

  return {
    isHyundaiMobisIrisEnabled: codes.has(HYUNDAI_MOBIS_IRIS_INTEGRATION_CODE),
    isMercedesMraEnabled:
      codes.has(MERCEDES_MRA_INTEGRATION_CODE) || codes.has(DAIMLER_MRA_INTEGRATION_CODE),
    isMerc5StarEnabled: codes.has(MERCEDES_5STAR_INTEGRATION_CODE),
    isMercCstarEnabled: codes.has(MERCEDES_CSTAR_INTEGRATION_CODE),
    isTenantIntegrationsSearchSuccess,
  };
}
